/**
 *
 * Asynchronously loads the component for AcceptInvite
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AcceptInvite = lazyLoad(
  () => import('./index'),
  module => module.AcceptInvite,
);
